<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="860px"
    top="4vh"
    append-to-body
    @close="close"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      :disabled="readonly"
      label-width="150px"
    >
      <el-form-item label="投保主体类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">个人</el-radio>
          <el-radio :label="2">单位</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="form.type === 1 ? '真实姓名' : '公司名称'"
            prop="name"
          >
            <el-input v-model.trim="form.name" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="营业执照编号">
            <el-input v-model.trim="form.license_no" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="省份" prop="province">
            <el-select
              v-model="form.province"
              filterable
              clearable
              placeholder="请选择省份"
              @change="handleProvinceChange"
            >
              <el-option
                v-for="item in provinces"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="城市" prop="city">
            <el-select
              v-model="form.city"
              filterable
              clearable
              placeholder="请选择城市"
              :loading="cityLoading"
            >
              <el-option
                v-for="item in cities"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务登记联系电话">
            <el-input v-model.trim="form.tax_mobile" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务开户银行名称">
            <el-input v-model.trim="form.tax_bank" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务开户银行账号">
            <el-input v-model.trim="form.tax_bank_no" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务登记地址">
            <el-input v-model.trim="form.tax_address" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="营业范围">
            <el-input
              v-model="form.business_scope"
              type="textarea"
              :rows="3"
              placeholder="请输入营业范围"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="一般纳税人资质">
            <company-qualification-upload
              v-model="form.tax_file_url"
              :disabled="readonly"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="开票信息采集表">
            <company-qualification-upload
              v-model="form.vat_file_url"
              :disabled="readonly"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="营业执照">
            <company-qualification-upload
              v-model="form.license_file_url"
              :disabled="readonly"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="校验状态" prop="checked">
            <el-radio-group v-model="form.checked">
              <el-radio :label="true">已校验</el-radio>
              <el-radio :label="false">未校验</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="close">{{ readonly ? "关闭" : "取消" }}</el-button>
      <el-button
        v-if="!readonly"
        type="primary"
        :loading="saving"
        @click="save"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  addCompany,
  getCompanyCityList,
  getCompanyInfo,
  getCompanyProvinceList,
  updateCompany
} from "@/api/company";
import CompanyQualificationUpload from "./CompanyQualificationUpload.vue";

const emptyForm = () => ({
  id: null,
  type: 1,
  name: "",
  license_no: "",
  province: "",
  city: "",
  tax_mobile: "",
  tax_bank: "",
  tax_bank_no: "",
  tax_address: "",
  business_scope: "",
  tax_file_url: "",
  vat_file_url: "",
  license_file_url: "",
  checked: true
});

export default {
  name: "InsuranceInformationForm",
  components: { CompanyQualificationUpload },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "add"
    },
    companyId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      cityLoading: false,
      provinces: [],
      cities: [],
      form: emptyForm(),
      rules: {
        type: [
          { required: true, message: "请选择投保主体类型", trigger: "change" }
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        province: [
          { required: true, message: "请选择省份", trigger: "change" }
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }]
      }
    };
  },
  computed: {
    readonly() {
      return this.mode === "view";
    },
    dialogTitle() {
      return {
        add: "新增投保信息",
        view: "查看投保信息",
        edit: "编辑投保信息"
      }[this.mode];
    }
  },
  watch: {
    visible(value) {
      if (value) this.initialize();
    }
  },
  methods: {
    async initialize() {
      this.form = emptyForm();
      this.cities = [];
      this.loading = true;
      try {
        await this.loadProvinces();
        if (this.mode !== "add" && this.companyId) {
          const res = await getCompanyInfo({ id: Number(this.companyId) });
          const data = res.data || {};
          this.form = {
            ...emptyForm(),
            ...data,
            id: Number(data.id || this.companyId),
            type: Number(data.type || 1),
            checked:
              data.checked === true ||
              String(data.checked) === "true" ||
              Number(data.checked) === 1
          };
          if (this.form.province) await this.loadCities(this.form.province);
        }
      } finally {
        this.loading = false;
        this.$nextTick(
          () => this.$refs.form && this.$refs.form.clearValidate()
        );
      }
    },
    async loadProvinces() {
      const res = await getCompanyProvinceList({ page: 1, rows: 1000 });
      const rows = res.rows || res.data || [];
      this.provinces = Array.from(
        new Set(rows.map(item => item.province || item.name).filter(Boolean))
      );
    },
    async loadCities(province) {
      if (!province) {
        this.cities = [];
        return;
      }
      this.cityLoading = true;
      try {
        const res = await getCompanyCityList({ province });
        const rows = res.data || res.rows || [];
        this.cities = Array.from(
          new Set(rows.map(item => item.city || item.name).filter(Boolean))
        );
      } finally {
        this.cityLoading = false;
      }
    },
    async handleProvinceChange(value) {
      this.form.city = "";
      await this.loadCities(value);
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = {
            name: this.form.name,
            license_no: this.form.license_no,
            province: this.form.province,
            city: this.form.city,
            tax_mobile: this.form.tax_mobile,
            tax_bank: this.form.tax_bank,
            tax_bank_no: this.form.tax_bank_no,
            tax_address: this.form.tax_address,
            business_scope: this.form.business_scope,
            tax_file_url: this.form.tax_file_url,
            vat_file_url: this.form.vat_file_url,
            license_file_url: this.form.license_file_url,
            type: Number(this.form.type),
            checked: Boolean(this.form.checked)
          };
          if (this.mode === "edit") {
            data.id = Number(this.form.id || this.companyId);
            await updateCompany(data);
          } else {
            await addCompany(data);
          }
          this.$message.success("保存成功");
          this.$emit("saved");
          this.close();
        } finally {
          this.saving = false;
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
/deep/ .el-select {
  width: 100%;
}
</style>
